import { useRef } from "react";
import ImgSmall from "./ImgSmall";
import { useIsMobile } from "@/hooks/useIsMobile";
import { Col, Row } from "@/utils/bootstrap";
import { getWidthFromDivElement } from "@/utils/functions/functions";
import EmblaSlider from "@/app/components/lib/Embla-slider";
import { TSlideWidith } from "@/app/components/lib/Embla-slider/EmblaSliderContainer";
interface props {
  imgs: string[];
}
const ImagesSlider: React.FC<props> = ({ imgs }) => {
  const divRef = useRef<HTMLDivElement>(null);
  const isMobile = useIsMobile();
  const divWidth = getWidthFromDivElement(divRef);
  const imgSize = isMobile ? 48 : 56;
  const spacing = isMobile ? 12 : 14;
  const sliderAccualWidth = imgs.length * (imgSize + spacing);
  const isRow = divWidth > sliderAccualWidth;
  return (
    <div ref={divRef} style={{ width: "100%", maxWidth: "100%" }}>
      {isRow ? (
        <Row style={{ gap: spacing, justifyContent: "center" }}>
          {imgs.map((image, index) => (
            <Col key={index} className="p-0 col-auto text-nowrap">
              <ImgSmall key={index} src={image} />
            </Col>
          ))}
        </Row>
      ) : (
        <EmblaSlider>
          <EmblaSlider.EmblaSliderViewport>
            <EmblaSlider.EmblaSliderContainer
              gap={spacing}
              slides={[
                ...imgs?.map((img) => ({
                  component: <ImgSmall key={img} src={img} />,
                  width: "auto" as TSlideWidith,
                })),
              ]}
            />
          </EmblaSlider.EmblaSliderViewport>
        </EmblaSlider>
      )}
    </div>
  );
};

export default ImagesSlider;
